export type CommercePlatform = "cafe24" | "naver";

export type PlatformUi = {
  key: CommercePlatform;
  name: string;
  shortName: string;
  edition: string;
  studioLabel: string;
  connectedLabel: string;
  headerLabel: string;
  accountLabel: string;
  publishingLabel: string;
  settingsDescription: string;
  persistenceLabel: string;
  persistencePendingLabel: string;
};

const PLATFORM_UI: Record<CommercePlatform, PlatformUi> = {
  cafe24: {
    key: "cafe24",
    name: "Cafe24",
    shortName: "Cafe24",
    edition: "Cafe24",
    studioLabel: "CAFE24 STUDIO",
    connectedLabel: "CAFE24 CONNECTED",
    headerLabel: "SNAPCAST / CAFE24",
    accountLabel: "CAFE24 MALL ID",
    publishingLabel: "CAFE24 PUBLISHING",
    settingsDescription: "Cafe24 연결 상태와 데이터 보관 정책을 관리합니다.",
    persistenceLabel: "Cafe24 쇼핑몰 저장소에 보관됨",
    persistencePendingLabel: "Cafe24 저장소로 옮기고 있어요",
  },
  naver: {
    key: "naver",
    name: "네이버 스마트스토어",
    shortName: "스마트스토어",
    edition: "Naver",
    studioLabel: "SMARTSTORE STUDIO",
    connectedLabel: "SMARTSTORE CONNECTED",
    headerLabel: "SNAPCAST / SMARTSTORE",
    accountLabel: "SMARTSTORE ACCOUNT",
    publishingLabel: "SMARTSTORE PUBLISHING",
    settingsDescription: "스마트스토어 연결 상태와 데이터 보관 정책을 관리합니다.",
    persistenceLabel: "스마트스토어 이미지 저장소에 보관됨",
    persistencePendingLabel: "스마트스토어 저장소로 옮기고 있어요",
  },
};

export function resolveCommercePlatform(
  hostname = typeof window === "undefined" ? "localhost" : window.location.hostname,
  search = typeof window === "undefined" ? "" : window.location.search,
): CommercePlatform {
  const normalized = hostname.trim().toLowerCase().split(":")[0];
  if (normalized === "naver.snapcast.esangdan.com") return "naver";
  if (normalized === "cafe24.snapcast.esangdan.com") return "cafe24";
  if (normalized === "localhost" || normalized === "127.0.0.1") {
    return new URLSearchParams(search).get("platform") === "naver"
      ? "naver"
      : "cafe24";
  }
  return "cafe24";
}

export const commercePlatform = resolveCommercePlatform();
export const platformUi = PLATFORM_UI[commercePlatform];

export function commerceProductUrl(
  accountId: string,
  productNo: number,
  providerUrl?: string,
) {
  if (providerUrl) {
    try {
      const parsed = new URL(providerUrl);
      const trusted = commercePlatform === "cafe24"
        ? parsed.protocol === "https:" && parsed.hostname.endsWith(".cafe24.com")
        : parsed.protocol === "https:" &&
          ["smartstore.naver.com", "brand.naver.com"].includes(parsed.hostname);
      if (trusted) return parsed.toString();
    } catch {
      // Fall through to the platform-safe destination below.
    }
  }
  if (commercePlatform === "cafe24") {
    return `https://${accountId}.cafe24.com/product/detail.html?product_no=${productNo}`;
  }
  return "https://sell.smartstore.naver.com/#/products/origin-list";
}
